import { Info } from "@tamagui/lucide-icons";

import ChatNote from "./ChatNote";

type QuestionHintProps = {
  hint: string;
};

export default function QuestionHint({ hint }: QuestionHintProps) {
  return (
    <ChatNote.Active Icon={Info} title="Why are we asking?" subtitle={hint} />
  );
}
